import { formatArray } from "./array";
import type { FormatOptions } from "./format.types";
import { formatObject } from "./object";

/**
 * Safely converts any value to string with proper handling for arrays and objects
 */
export const formatString = (options: FormatOptions): string => {
  const { value } = options;

  if (Array.isArray(value)) {
    return formatArray(options);
  }

  if (typeof value === "object") {
    return formatObject(options);
  }

  return String(value);
};
